import { render } from "./FloatingBasket.vue?vue&type=template&id=a3f6a5fa"
import script from "./FloatingBasket.vue?vue&type=script&lang=js"
export * from "./FloatingBasket.vue?vue&type=script&lang=js"

import "./FloatingBasket.vue?vue&type=style&index=0&id=a3f6a5fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__